import { atom } from 'jotai';
import { $ArticleDetail } from 'shared/atoms';
import { $CurrentArticleId } from '@article/shared/atoms/current-article-id';
import { ArticleDetailUtil, TArticleDetail } from 'shared/models';

export const $CurrentArticle = atom((get) => {
  const currentArticleId = get($CurrentArticleId);
  return get($ArticleDetail(currentArticleId));
});

/**
 * get null when current article is not available
 *
 * e.g. used for short circuit logic.
 */
export const $CurrentAvailableArticleOrNull = atom((get) => {
  const article = get($CurrentArticle);
  return ArticleDetailUtil.isArticleAvailable(article) ? article : null;
});

/**
 * force cast current article to TArticleDetail
 *
 * use this only when you are sure that current article is available to show
 */
export const $CurrentArticleAsAvailable = atom((get) => {
  return get($CurrentArticle) as TArticleDetail;
});
